
export const modifyTableData = (tableColumns, rowData) => {

	//because there are several different tables using CopyTableDataClipboard
	//so need to loop the table column name to match the rowData
	//and the modifyTableData will be reuseable

	const namesList = tableColumns.map((col)=> col.name);
	const filteredRowData  = rowData.map(obj =>
							Object.keys(obj)
							.filter(key => namesList.includes(key))
							.reduce((newObj, key) => {
								newObj[key] = obj[key];
								return newObj;
							}, {}),
		);

	const modifiedRowData = filteredRowData .map(item => {
							return tableColumns.reduce((tableCol, column) => {
							tableCol[column.title] = item[column.name];
							return tableCol;
							}, {})
		});

	return modifiedRowData;
};